import React from "react";

const RightArrowNoTail = ({ width = 24, height = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M13.3142 12.0705L8.36421 7.12049C8.18205 6.93189 8.08126 6.67929 8.08353 6.41709C8.08581 6.1549 8.19098 5.90408 8.37639 5.71867C8.5618 5.53327 8.81261 5.4281 9.07481 5.42582C9.337 5.42354 9.58961 5.52434 9.77821 5.70649L15.4352 11.3635C15.6227 11.551 15.728 11.8053 15.728 12.0705C15.728 12.3357 15.6227 12.59 15.4352 12.7775L9.77821 18.4345C9.58961 18.6167 9.337 18.7174 9.07481 18.7152C8.81261 18.7129 8.5618 18.6077 8.37639 18.4223C8.19098 18.2369 8.08581 17.9861 8.08353 17.7239C8.08126 17.4617 8.18205 17.2091 8.36421 17.0205L13.3142 12.0705Z"
        fill="#1A325D"
      />
    </svg>
  );
};

export default RightArrowNoTail;
